export default __webpack_public_path__ + "static/media/logo.3eb1b459.svg";